<script>
export default {
  data: () => ({
    pagination: null,
  }),

  computed: {
    isPaginate() {
      return !(this.pagination == null || this.pagination.totalPage === 1);
    },
  },

  methods: {
    setPaginationData(pagination) {
      this.pagination = pagination;
    },

    resetData() {
      this.pagination = null;
    }
  },
};
</script>
